import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Input, Form, Dropdown, Button } from 'semantic-ui-react';
import * as action from '../../../actions/videos/trainingVideos';
import { getTags } from '../../../actions/tags/getTags';

const DEFAULT_TYPE_OF_TRAINING_VIDEOS = [
  { text: 'Основное видео', value: 'basicWorkout' },
  { text: 'Разминка', value: 'warm-up' },
  { text: 'Заминка', value: 'coolDownWorkout' },
  { text: 'Саморазвитие', value: 'self-development' },
  { text: 'Мотивация', value: 'motivation' },
  { text: 'Приветствие', value: 'welcome' },
  { text: 'FAQ', value: 'faq' },
];

const ChangeVideos = ({
  setChoosedVideosTags,
  trainingVideo,
  createVideo,
  changeVideo,
  getTags,
  allVideoTags,
  isCreateVideoLoading,
}) => {
  const [templateName, setTemplateName] = useState((trainingVideo && trainingVideo.name) || '');
  const [videoType, seVideoType] = useState(
    (trainingVideo &&
      trainingVideo.video_type &&
      DEFAULT_TYPE_OF_TRAINING_VIDEOS[trainingVideo.video_type - 1].value) ||
      '',
  );
  const [videoTypeCurrentIndex, setVideoTypeCurrentIndex] = useState(0);
  const [choosedTags, setchoosedTags] = useState(
    (trainingVideo && trainingVideo.tags && trainingVideo.tags.map((tag) => tag.name)) || [],
  );
  const [uploadedVideo, setUploadedVideo] = useState((trainingVideo && trainingVideo.url) || '');
  const [isNameNotFilled, setIsNameNotFilled] = useState(false);
  const [isTagsNotSelected, setIsTagsNotSelected] = useState(false);
  const [isTypeNotSelected, setIsTypeNotSelected] = useState(false);
  const [isVideosNotSelected, setIsVideosNotSelected] = useState(false);

  const handleCheck = React.useCallback(
    (tagName) => {
      setIsTagsNotSelected(false);
      let newChoosedTagsIds = JSON.parse(JSON.stringify(choosedTags));
      if (newChoosedTagsIds.includes(tagName)) {
        newChoosedTagsIds = choosedTags.filter((choosedTagId) => choosedTagId !== tagName);
      } else {
        newChoosedTagsIds.push(tagName);
      }
      setchoosedTags(newChoosedTagsIds);
      setChoosedVideosTags(newChoosedTagsIds);
    },
    [setIsTagsNotSelected, choosedTags, setchoosedTags, setChoosedVideosTags],
  );

  const handleVideoName = React.useCallback(
    (e) => {
      setTemplateName(e.target.value);
      setIsNameNotFilled(false);
    },
    [setTemplateName, setIsNameNotFilled],
  );

  const handleVideoTypeSelect = React.useCallback(
    (e, data) => {
      setIsTypeNotSelected(false);
      DEFAULT_TYPE_OF_TRAINING_VIDEOS.forEach((type, i) => {
        if (type.value === data.value) setVideoTypeCurrentIndex(i);
      });
      seVideoType(data.value);
    },
    [setIsTypeNotSelected, seVideoType],
  );

  const resetFilters = React.useCallback(() => {
    setChoosedVideosTags([]);
    setchoosedTags([]);
  }, [setChoosedVideosTags, setchoosedTags]);

  const handleUploadVidoes = React.useCallback(
    (e) => {
      const file = e.target.files[0];
      setIsVideosNotSelected(false);
      setUploadedVideo(file);
    },
    [setIsVideosNotSelected, setUploadedVideo],
  );

  const handleSubmit = React.useCallback(() => {
    let allFieldsAreFilled = true;
    if (!choosedTags.length) {
      setIsTagsNotSelected(true);
      allFieldsAreFilled = false;
    }
    if (!templateName) {
      setIsNameNotFilled(true);
      allFieldsAreFilled = false;
    }
    if (!videoType) {
      setIsTypeNotSelected(true);
      allFieldsAreFilled = false;
    }
    if (!uploadedVideo) {
      setIsVideosNotSelected(true);
      allFieldsAreFilled = false;
    }
    if (!allFieldsAreFilled) return;
    if (!!trainingVideo && trainingVideo.id) {
      changeVideo({
        id: (!!trainingVideo && trainingVideo.id) || null,
        video_type: videoTypeCurrentIndex + 1,
        url: uploadedVideo,
        name: templateName,
        tags: choosedTags,
      });
    } else {
      createVideo({
        video_type: videoTypeCurrentIndex + 1,
        url: uploadedVideo,
        name: templateName,
        tags: choosedTags,
      });
    }
  }, [
    choosedTags,
    templateName,
    videoType,
    uploadedVideo,
    setIsVideosNotSelected,
    createVideo,
    changeVideo,
    setIsTagsNotSelected,
    setIsNameNotFilled,
    setIsTypeNotSelected,
  ]);

  useEffect(() => {
    getTags();
  }, []);
  return (
    <ChangeVideoBlock>
      <MainTitle>Управление видео тренировок</MainTitle>
      <Form>
        <Form.Field error={isNameNotFilled}>
          <Input
            placeholder="Введите название видео..."
            value={templateName}
            onChange={handleVideoName}
          />
        </Form.Field>
        <Form.Field error={isVideosNotSelected}>
          <div>
            {uploadedVideo && uploadedVideo.name !== '' && (
              <UploadedVideo>{`Загружено видео: ${
                uploadedVideo.name ? uploadedVideo.name : uploadedVideo
              }, загрузить другое?`}</UploadedVideo>
            )}
            <input id="file-input" type="file" name="file" multiple onChange={handleUploadVidoes} />
          </div>
        </Form.Field>
        <Form.Field error={isTypeNotSelected}>
          <Dropdown
            placeholder="Выберите тип видео"
            search
            selection
            value={videoType}
            onChange={handleVideoTypeSelect}
            options={DEFAULT_TYPE_OF_TRAINING_VIDEOS}
          />
        </Form.Field>
        <Form.Field error={isTagsNotSelected}>
          <FilterWrapper>
            <CheckboxWrapper>
              {!!allVideoTags.length &&
                allVideoTags.map((tag) => (
                  <Label key={tag.tag_id}>
                    <Input
                      key={tag.tag_id}
                      type="checkbox"
                      style={{ width: 'auto' }}
                      value={tag.tag_id}
                      checked={choosedTags.includes(tag.name)}
                      onChange={() => handleCheck(tag.name)}
                    />
                    <TagName>{tag.name}</TagName>
                  </Label>
                ))}
              {!allVideoTags.length && (
                <NoTagsMessage>
                  <p>Теги не найдены</p>
                </NoTagsMessage>
              )}
              <ButtonWrapper>
                <ResetFiltersButton onClick={resetFilters}>Сбросить все теги</ResetFiltersButton>
              </ButtonWrapper>
            </CheckboxWrapper>
          </FilterWrapper>
        </Form.Field>
        <SubmitButton>
          <Button positive loading={isCreateVideoLoading} type="submit" onClick={handleSubmit}>
            Сохранить
          </Button>
        </SubmitButton>
      </Form>
    </ChangeVideoBlock>
  );
};

const mapStateToProps = (state) => {
  const { trainingVideo, isCreateVideoLoading } = state.trainingVideos;
  const { allVideoTags } = state.getTags;
  return {
    trainingVideo,
    allVideoTags,
    isCreateVideoLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setChoosedVideosTags: (tags) => {
      dispatch(action.setChoosedVideosTags(tags));
    },
    createVideo: ({ video_type, url, name, tags }) => {
      dispatch(action.createVideo({ video_type, url, name, tags }));
    },
    changeVideo: ({ id, video_type, url, name, tags }) => {
      dispatch(action.changeVideo({ id, video_type, url, name, tags }));
    },
    getTags: () => {
      dispatch(getTags());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeVideos);

const MainTitle = styled.h1`
  font-size: 24px;
  text-align: center;
  padding-top: 10px;
`;

const NoTagsMessage = styled.div`
  font-size: 24px;
  text-align: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const TagName = styled.p`
  margin-left: 10px;
`;
const UploadedVideo = styled.p`
  color: gray;
`;

const ChangeVideoBlock = styled.div`
  width: 50%;
  margin: 0 auto;
`;

const FilterWrapper = styled.div`
  width: 100%;
  margin: 15px auto;
  box-sizing: border-box;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  background: #fff;
  @media (max-width: 992px) {
    width: 75%;
  }
`;

const CheckboxWrapper = styled.div`
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-self: flex-start;
  @media (max-width: 580px) {
    width: 100%;
    padding-left: 20%;
  }
`;

const Label = styled.label`
  display: flex;
  cursor: pointer;
  align-items: center;
  margin: 3px 0;
  width: 200px;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 580px) {
    width: 100%;
  }
`;

const ResetFiltersButton = styled.button`
  padding: 10px;
  margin: 15px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  background: #db2828;
  border: none;
  border-radius: 5px;
  @media (max-width: 580px) {
    margin: 10px 0;
  }
`;

const SubmitButton = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/Components/Videos/ChangeVideosList/ChangeVideos.jsx